import React from 'react'
import './experience.css'
import {BsPatchCheckFill} from 'react-icons/bs';

const  Experience=()=> {
  return (
    <section id='experience'>
        <h5 >What Skill I Have</h5>
         <h2>My Experience</h2>

    <div className='container experience_container'>
 
      
      <div className='experience_frontend'>
        <h3>Frontend Development</h3>
        <div className='experience_content'>
          <article className='experience_details'>
              <BsPatchCheckFill className='experience_details_icon'/>
              <h4>HTML</h4>
              <small>Experienced</small>
          </article>
          <article className='experience_details'>
              <BsPatchCheckFill className='experience_details_icon'/>
              <h4>CSS</h4>
              <small>Experienced</small>
          </article>
          <article className='experience_details'>
              <BsPatchCheckFill className='experience_details_icon'/>
              <h4>React</h4>
              <small>Experienced</small>
          </article>
          <article className='experience_details'>
              <BsPatchCheckFill className='experience_details_icon'/>
              <h4>BootStrap</h4>
              <small>Experienced</small>
          </article>
          <article className='experience_details'>
              <BsPatchCheckFill className='experience_details_icon'/>
              <h4>JavaScript</h4>
              <small>InterMediate</small>
          </article>
          <article className='experience_details'>
              <BsPatchCheckFill className='experience_details_icon'/>
              <h4>jquery</h4>
              <small>InterMediate</small>
          </article>
        </div>
      </div>

      <div className='experience_backend'>
        <h3>Backend Development</h3>
        <div className='experience_content'>
          <article className='experience_details'>
              <BsPatchCheckFill className='experience_details_icon'/>
              <h4>Node js</h4>
              <small>Intermediate</small>
          </article>
          <article className='experience_details'>
              <BsPatchCheckFill className='experience_details_icon'/>
              <h4>Express</h4>
              <small>Intermediate</small>
          </article>
          <article className='experience_details'>
              <BsPatchCheckFill className='experience_details_icon'/>
              <h4>MongoDb</h4>
              <small>Intermediate</small>
          </article>
          <article className='experience_details'>
              <BsPatchCheckFill className='experience_details_icon'/>
              <h4>MySQL</h4>
              <small>Intermediate</small>
          </article>
          <article className='experience_details'>
              <BsPatchCheckFill className='experience_details_icon'/>
              <h4>Python</h4>
              <small>Basic</small>
          </article>
        </div>
      </div>
    </div>

    </section>
  )
}

export default Experience